// extracted by mini-css-extract-plugin
export default {"lds-ellipsis":"styles_lds-ellipsis__yWwi5","lds-ellipsis1":"styles_lds-ellipsis1__sGdvc","lds-ellipsis2":"styles_lds-ellipsis2__BrJXD","lds-ellipsis3":"styles_lds-ellipsis3__9G+8U"};